import React from 'react';

/**
 * Klickbarer Tabellen-Spaltenkopf (`<th>`) zum Sortieren.
 *
 * Zeigt einen Pfeil für die aktive Spalte (▲ aufsteigend / ▼ absteigend) und
 * ein dezentes ↕ für inaktive, aber sortierbare Spalten.
 *
 * @param {Object}   props
 * @param {string}   props.label      Sichtbarer Spaltentitel.
 * @param {string}   props.columnKey  Schlüssel dieser Spalte.
 * @param {string}   props.sortKey    Aktuell sortierter Spaltenschlüssel.
 * @param {'asc'|'desc'} props.sortDir Aktuelle Sortierrichtung.
 * @param {(key: string) => void} props.onSort Klick-Handler.
 * @param {'left'|'right'} [props.align] Ausrichtung (Standard: links).
 */
export default function SortHeader({
  label,
  columnKey,
  sortKey,
  sortDir,
  onSort,
  align = 'left',
}) {
  const active = sortKey === columnKey;
  const pfeil = active ? (sortDir === 'asc' ? '▲' : '▼') : '↕';

  return (
    <th className={`px-4 py-3 font-medium ${align === 'right' ? 'text-right' : ''}`}>
      <button
        type="button"
        onClick={() => onSort(columnKey)}
        aria-sort={active ? (sortDir === 'asc' ? 'ascending' : 'descending') : 'none'}
        className="inline-flex items-center gap-1 font-mono uppercase tracking-wider transition-colors hover:text-ink"
      >
        <span>{label}</span>
        <span className={`text-[10px] ${active ? 'text-ink' : 'text-ink-muted/60'}`}>
          {pfeil}
        </span>
      </button>
    </th>
  );
}
